export default __webpack_public_path__ + "static/media/ricotta.f5475079.png";